import { useContext } from 'react'
import { useEffect } from 'react'

import useLoyaltyLinkLazy from 'Stores/LoyaltyStore/useLazyLoyaltyLink'

import { StorageAccessor } from 'Utilities/LocalStorageUtility/LocalStorageUtility'

import { NotificationContext } from 'Contexts/NotificationContext/NotificationContext'

import { useLazyFeatureFlag } from 'Hooks/useFeatureFlag/useFeatureFlag'

const cacheKey = 'Loyalty_Notification_Shown'
const LoyaltyPointsAvailableNotification = () => {
  const { PushNotification } = useContext(NotificationContext)
  const loyaltyLink = useLoyaltyLinkLazy()
  const featureFlag = useLazyFeatureFlag('Loyalty_Notifications_Enabled', !!loyaltyLink?.currentPoints?.redeemablePoints)

  useEffect(() => {
    const hasBeenShown = StorageAccessor.sessionStorage.getObj(cacheKey)

    if (loyaltyLink?.currentPoints?.redeemablePoints && featureFlag && !hasBeenShown) {
      PushNotification(
        `You have ${loyaltyLink.currentPoints.redeemableDollarValue.string} to spend!`,
        null,
        5000,
        null,
        {
          icon: 'rewards',
          brand: 'primary',
        },
        null,
        null,
        'primary',
      )
      StorageAccessor.sessionStorage.setObj(cacheKey, true)
    }
  }, [loyaltyLink, featureFlag])

  return null
}

export default LoyaltyPointsAvailableNotification
